module.exports = __webpack_public_path__ + "img/1.097ed065.jpg";